import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { Observable } from 'rxjs';

import { environment } from 'src/environments/environment';
import { BaseResponse } from 'src/app/_shared/models/base-response.model';
import { Role } from '../models/user.model';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class RoleService {

  private uri: string = environment.url;

  constructor(private _http: HttpClient) { }

  public getRolesNew(): Observable<JSON>{
    return this._http.get<JSON>(`${this.uri}/config/role`).pipe(
      map(response => response)
    );
  }

  public getRoles(): Observable<BaseResponse<Role[]>>{
    return this._http.get<BaseResponse<Role[]>>(`${this.uri}/config/role`).pipe(
      map(response => response)
    );
  }
}
